import { OrgRefScope, OrgScope } from "../../../../types/gqlTypes/graphql"

export function generateOrgRefScope(
  scope: OrgScope,
  districtId: string,
  schoolId?: string | null,
  teacherId?: string | null,
  classId?: string | null,
  studentId?: string | null
): OrgRefScope {
  return {
    scope,
    ...(districtId && { districtId }),
    ...(schoolId && { schoolId }),
    ...(teacherId && { teacherId }),
    ...(classId && { classId }),
    ...(studentId && { studentId })
  }
}

export function getScopeBasedOnOrgFilters(
  districtId?: string,
  schoolId?: string,
  teacherId?: string,
  classId?: string,
  studentId?: string
): OrgScope {
  // Return the last filter as our scope
  if (studentId) return "STUDENT"
  if (classId) return "CLASS"
  if (teacherId) return "TEACHER"
  if (schoolId) return "SCHOOL"
  if (districtId) return "DISTRICT"
}

// OrgScopes from the less specific to more specific.
export const ORG_SCOPES_SEQUENCE = [
  "DISTRICT",
  "SCHOOL",
  "TEACHER",
  "CLASS",
  "STUDENT"
]

export const compareOrgScopes = (
  orgScopeA: OrgScope,
  orgScopeB: OrgScope
): number => {
  const orgScopeAIndex = ORG_SCOPES_SEQUENCE.indexOf(orgScopeA)
  const orgScopeBIndex = ORG_SCOPES_SEQUENCE.indexOf(orgScopeB)
  return orgScopeAIndex - orgScopeBIndex
}
